import React, { memo } from "react";

import "./EmptyBoardItem.css";
import { LabelStyle } from "../types";

interface Props {
    labelStyle: LabelStyle;
}

const EmptyBoardItem: React.FC<Props> = function ({ labelStyle }: Props) {
    return (
        <div className="empty_board_item" style={{ backgroundColor: labelStyle.color }}>
            <div className="empty_board_item__card" style={{ backgroundColor: labelStyle.colorInactive }} />
        </div>
    );
};
export default memo(EmptyBoardItem);
